import { instance } from '@/services/avik-api-gateway'
import { SearchDeviationMissingDistance } from '@/types/search-deviation-missing-distance'
import { AxiosResponse } from 'axios'

export function getDeviationMissingDistance(): Promise<
  AxiosResponse<SearchDeviationMissingDistance[]>
> {
  return instance.get(`/search/deviation-missing-distance`)
}
